import { createFileRoute } from '@tanstack/react-router';
import { UnitDetailView, UnitsProvider } from '@ludolio/shared-units';
import { useLibrarianUnitsModule } from '@/units/librarianUnitsModule';

export const Route = createFileRoute('/_authenticated/units/$unitId')({
  component: UnitDetailPage,
});

function UnitDetailPage() {
  const { unitId } = Route.useParams();
  const module = useLibrarianUnitsModule();
  return (
    <UnitsProvider module={module}>
      <UnitDetailView key={unitId} unitId={unitId} />
    </UnitsProvider>
  );
}
